export const errorCodes = {
  ACCOUNT_ALREADY_ACTIVE: 400886,
  INVALID_ACTIVATION_LINK: 400887,
  PATIENT_DATA_MISSING: 400105,
  EXTERNAL_USER_NOT_FOUND: 40028,
  EMAIL_ALREADY_TAKEN: 40030,
};
